import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Building2, Inbox, Newspaper, Settings, LogOut, ExternalLink, BarChart3 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/immobili", label: "Immobili", icon: Building2 },
  { to: "/admin/lead", label: "Richieste & Lead", icon: Inbox },
  { to: "/admin/blog", label: "Blog", icon: Newspaper },
  { to: "/admin/statistiche", label: "Statistiche", icon: BarChart3 },
  { to: "/admin/impostazioni", label: "Impostazioni", icon: Settings },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[#14263D] flex">
      <aside className="w-64 bg-[#101E31] text-white flex-col hidden lg:flex fixed h-screen">
        <div className="p-6 border-b border-white/10">
          <div className="font-display text-xl font-bold">EDILSTUDIO</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#F5A623] font-mono mt-1">Pannello Admin</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${isActive ? "bg-[#2472C8] text-white" : "text-white/70 hover:bg-white/5 hover:text-white"}`} data-testid={`admin-nav-${n.label.toLowerCase().split(" ")[0]}`}>
              <n.icon className="w-5 h-5" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-white/70 hover:bg-white/5 hover:text-white"><ExternalLink className="w-5 h-5" /> Vedi sito</Link>
          <button onClick={doLogout} className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-white/70 hover:bg-white/5 hover:text-white" data-testid="admin-logout"><LogOut className="w-5 h-5" /> Esci</button>
        </div>
      </aside>

      <div className="flex-1 lg:ml-64">
        <header className="bg-[#101E31] lg:hidden text-white p-4 flex items-center justify-between">
          <span className="font-display font-bold">EDILSTUDIO Admin</span>
          <button onClick={doLogout} className="text-white/70"><LogOut className="w-5 h-5" /></button>
        </header>
        <div className="lg:hidden bg-[#101E31] px-4 pb-3 flex gap-2 overflow-x-auto hide-scrollbar">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `whitespace-nowrap px-3 py-2 rounded-lg text-xs font-medium ${isActive ? "bg-[#2472C8] text-white" : "bg-white/5 text-white/70"}`}>{n.label}</NavLink>
          ))}
        </div>
        <main className="p-4 sm:p-8 bg-[#EEF4F9] min-h-screen">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
